var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "route-user-form" }, [
    _c(
      "div",
      { staticClass: "padding-box" },
      [
        _c(
          "cms-heading",
          {
            staticClass: "page-heading",
            attrs: { level: "1", title: _vm.pageTitle, icon: "magicon-user" },
          },
          [
            _c(
              "cms-button",
              {
                attrs: { color: "positive", loading: _vm.submitting },
                on: { click: _vm.submit },
              },
              [_vm._v("Opslaan")]
            ),
            _c(
              "cms-button",
              {
                attrs: {
                  color: "medium-dark",
                  type: "bordered",
                  to: { name: "users" },
                },
              },
              [_vm._v("Annuleren")]
            ),
            _vm.itemId && _vm.isAdmin
              ? _c(
                  "cms-button",
                  {
                    staticStyle: { "margin-right": "10px" },
                    attrs: { color: "negative", type: "bordered" },
                    on: { click: _vm.deleteUser },
                  },
                  [_vm._v("Gebruiker verwijderen")]
                )
              : _vm._e(),
            _vm.itemId
              ? _c(
                  "cms-button",
                  {
                    attrs: { color: "negative", type: "bordered" },
                    on: { click: _vm.sendNewPassword },
                  },
                  [_vm._v("Wachtwoord reset mail sturen")]
                )
              : _vm._e(),
          ],
          1
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "spinner",
                rawName: "v-spinner",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            staticClass: "wm-block",
          },
          [
            !_vm.loading
              ? _c(
                  "cms-form",
                  { on: { submit: _vm.submit } },
                  [
                    _c("cms-form-input", {
                      attrs: { title: "Voornaam", name: "firstName" },
                      model: {
                        value: _vm.editUser.firstName,
                        callback: function ($$v) {
                          _vm.$set(_vm.editUser, "firstName", $$v)
                        },
                        expression: "editUser.firstName",
                      },
                    }),
                    _c("cms-form-input", {
                      attrs: { title: "Achternaam", name: "lastName" },
                      model: {
                        value: _vm.editUser.lastName,
                        callback: function ($$v) {
                          _vm.$set(_vm.editUser, "lastName", $$v)
                        },
                        expression: "editUser.lastName",
                      },
                    }),
                    _c("cms-form-input", {
                      attrs: { title: "Initialen", name: "initials" },
                      model: {
                        value: _vm.editUser.initials,
                        callback: function ($$v) {
                          _vm.$set(_vm.editUser, "initials", $$v)
                        },
                        expression: "editUser.initials",
                      },
                    }),
                    _c("cms-form-input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required|email",
                          expression: "'required|email'",
                        },
                      ],
                      attrs: {
                        title: "E-mail adres",
                        name: "email",
                        "data-vv-as": "E-mail adres",
                        error: _vm.error("email"),
                      },
                      model: {
                        value: _vm.editUser.email,
                        callback: function ($$v) {
                          _vm.$set(_vm.editUser, "email", $$v)
                        },
                        expression: "editUser.email",
                      },
                    }),
                    _vm.itemId
                      ? [
                          _c("cms-form-input", {
                            attrs: {
                              title: "Nieuw wachtwoord",
                              type: "password",
                              name: "password",
                              placeholder: "Optioneel",
                            },
                            model: {
                              value: _vm.editUser.password,
                              callback: function ($$v) {
                                _vm.$set(_vm.editUser, "password", $$v)
                              },
                              expression: "editUser.password",
                            },
                          }),
                          (_vm.editUser.password &&
                            _vm.editUser.password.length) ||
                          !_vm.itemId
                            ? _c("cms-form-input", {
                                attrs: {
                                  title: "Wachtwoord herhalen",
                                  type: "password",
                                  name: "passwordRepeat",
                                  "data-vv-as": "Herhaalde wachtwoord",
                                  error: _vm.error("passwordRepeat"),
                                },
                                model: {
                                  value: _vm.passwordRepeat,
                                  callback: function ($$v) {
                                    _vm.passwordRepeat =
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                  },
                                  expression: "passwordRepeat",
                                },
                              })
                            : _vm._e(),
                        ]
                      : _vm._e(),
                    _vm._l(_vm.applications, function (application) {
                      return _vm.isAdmin
                        ? _c("cms-form-dropdown", {
                            key: application.value,
                            attrs: {
                              value: _vm.getApplicationRoleValue(application),
                              title: _vm._f("application")(application),
                              options: _vm.getApplicationRoles(application),
                              empty:
                                application != "MIJN_AVECO"
                                  ? `Geen toegang`
                                  : null,
                            },
                            on: {
                              input: function ($event) {
                                return _vm.onApplicationRoleUpdate(
                                  application,
                                  $event
                                )
                              },
                            },
                          })
                        : _vm._e()
                    }),
                  ],
                  2
                )
              : _vm._e(),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }